@if (isReferralQuestionsExist || isQuestionnairesExist || isGroupedScreeningQuestionsExist) {
  @if (hasNewStyling) {
    <div layout-vertical gap-small>
      @if (isQuestionnairesExist) {
        <rt-collapsible-card
          rtCollapsibleCardAnalytics
          analyticsKey="questionnaires"
          uniqKey="candidate-questionnaires"
          hasHeaderDivider="true"
        >
          <div leftSlot>
            <rt-heading>
              {{ this.translations.titles.questionnaires | translate }}
            </rt-heading>
          </div>
          <div collapsible layout-full-width>
            <rt-candidate-questions-results
              [mode]="QuestionsMode.Questionnaires"
              [data]="questionnaires"
              [visibilityTplRef]="visibilityTplRef"
            >
            </rt-candidate-questions-results>
          </div>
        </rt-collapsible-card>
      }
      @if (isGroupedScreeningQuestionsExist) {
        <rt-collapsible-card
          rtCollapsibleCardAnalytics
          analyticsKey="screeningQuestions"
          uniqKey="candidate-screening-questions"
          hasHeaderDivider="true"
        >
          <div leftSlot>
            <rt-heading>
              {{ this.translations.titles.questions | translate }}
            </rt-heading>
          </div>
          <div collapsible layout-full-width>
            <rt-candidate-questions-results
              [mode]="QuestionsMode.GroupedScreeningQuestions"
              [data]="groupedScreeningQuestions"
              [visibilityTplRef]="visibilityTplRef"
              [hasBooleanFlagAnswers]="true"
            >
            </rt-candidate-questions-results>
          </div>
        </rt-collapsible-card>
      }
      @if (isReferralQuestionsExist) {
        <rt-collapsible-card
          rtCollapsibleCardAnalytics
          analyticsKey="referralQuestions"
          uniqKey="candidate-referral-questions"
          hasHeaderDivider="true"
        >
          <div leftSlot>
            <rt-heading>
              {{ this.translations.titles.referralQuestions! | translate }}
            </rt-heading>
          </div>
          <div collapsible layout-full-width>
            <rt-candidate-questions-results
              [mode]="QuestionsMode.ReferralQuestions"
              [data]="referralsQuestions"
              [visibilityTplRef]="visibilityTplRef"
            >
            </rt-candidate-questions-results>
          </div>
        </rt-collapsible-card>
      }
    </div>
  } @else {
    <rt-box variant="vertical no-padding">
      <div class="header" layout-horizontal padding-lr padding-top>
        @if (!isMoreThenOneSection && title) {
          <rt-heading variant="heading large light">
            {{ title | translate }}
          </rt-heading>
        } @else {
          <rt-segmented-control
            [type]="'view-switcher'"
            [segmentedButtons]="segmentedButtons"
            (segmentedButtonClicked)="handleSectionButtonClick($event)"
          >
          </rt-segmented-control>
        }
      </div>

      <div>
        @switch (mode) {
          @case (QuestionsMode.Questionnaires) {
            <rt-candidate-questions-results
              [mode]="QuestionsMode.Questionnaires"
              [data]="questionnaires"
              [visibilityTplRef]="visibilityTplRef"
            >
            </rt-candidate-questions-results>
          }

          @case (QuestionsMode.ReferralQuestions) {
            <rt-candidate-questions-results
              [mode]="QuestionsMode.ReferralQuestions"
              [data]="referralsQuestions"
              [visibilityTplRef]="visibilityTplRef"
            >
            </rt-candidate-questions-results>
          }

          @case (QuestionsMode.GroupedScreeningQuestions) {
            <rt-candidate-questions-results
              [mode]="QuestionsMode.GroupedScreeningQuestions"
              [data]="groupedScreeningQuestions"
              [visibilityTplRef]="visibilityTplRef"
              [hasBooleanFlagAnswers]="true"
            >
            </rt-candidate-questions-results>
          }
        }
      </div>
    </rt-box>
  }
}
